<template>
  <div id="table_medsos">
    <div class="row m-b-10">
      <div class="col-md-8">
        <i class="bi bi-info-circle text-blue" /> Menampilkan daftar akun yang
        memiliki posting sesuai dengan kata kunci yang dimonitor.
      </div>
      <div class="col-md-4" align="right">
        <form action="#" @submit.prevent="searchData">
          <div
            class="form-group input-group input-group-left transparent no-margin"
          >
            <div
              class="input-group-prepend"
              @click="showFilter"
              style="cursor: pointer"
              title="Filter Data"
            >
              <span class="input-group-text transparent">
                <i class="bi bi-funnel-fill"></i>
              </span>
            </div>
            <input
              type="text"
              placeholder="Masukan nama akun dan tekan enter"
              v-model="q_account"
              class="form-control"
            />
          </div>
        </form>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered" id="datatable">
        <thead>
          <tr>
            <th width="5%" class="text-center">No</th>
            <th width="5%" class="text-center">Site</th>
            <th>Akun</th>
            <th
              width="15%"
              class="text-center"
              style="cursor: pointer"
              @click="sort('mentions')"
            >
              Mention <i class="bi bi-chevron-expand pull-right" />
            </th>
            <th
              width="15%"
              class="text-center"
              style="cursor: pointer"
              @click="sort('esmr')"
            >
              Reach <i class="bi bi-chevron-expand pull-right" />
            </th>
            <th
              width="15%"
              class="text-center"
              style="cursor: pointer"
              @click="sort('engagement')"
            >
              Engagement <i class="bi bi-chevron-expand pull-right" />
            </th>
            <th
              width="15%"
              class="text-center"
              style="cursor: pointer"
              @click="sort('followers')"
            >
              Follower <i class="bi bi-chevron-expand pull-right" />
            </th>
            <th width="5%" class="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="data == null">
            <td colspan="8">
              <loader-component :with_text="true" text="Mohon Tunggu" />
            </td>
          </tr>
          <tr v-else-if="data_empty">
            <td align="center" colspan="8">Mohon maaf, data tidak tersedia!</td>
          </tr>
          <tr v-else v-for="(row, index) in data" :key="index">
            <td class="text-center">{{ start_count + index }}</td>
            <td class="text-center">
              <i v-if="row.source == 'review'" class="bi bi-phone" />
              <i
                v-else
                :class="icon_sources[row.source] + ' icon-' + row.source"
              />
            </td>
            <td>
              <a href="#" @click.prevent="showPost(index)" class="m-r-5">{{
                row.account
              }}</a>
              <span
                v-if="cekPers(row._id)"
                class="bg-orange label label-pers text-white p-t-1 p-b-1 fs-10"
                title="Akun ini adalah Pers"
                ><i class="bi bi-newspaper" /> Pers</span
              >
              <span
                v-if="cekMarks(row._id)"
                class="bg-complete label text-white p-t-1 p-b-1 fs-10 m-l-5"
                title="Akun ini ditandai"
              >
                <i class="bi bi-bell"></i> Ditandai</span
              >
            </td>
            <td class="text-center">{{ row.mentions | thousandSeparator }}</td>
            <td class="text-center">{{ row.esmr | thousandSeparator }}</td>
            <td class="text-center">
              {{ row.engagement | thousandSeparator }}
            </td>
            <td class="text-center">{{ row.followers }}</td>
            <td class="text-center">
              <div class="dropdown">
                <button
                  class="btn btn-sm dropdown-toggle"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  aria-label="dropdown"
                  @click="btnToggle"
                >
                  <i class="bi bi-three-dots-vertical"></i>
                </button>
                <div class="dropdown-menu" :data-order="index">
                  <router-link
                    :to="{
                      path: '/detail-akun',
                      query: { account: row.account, key: encodeId(row._id) },
                    }"
                    class="dropdown-item"
                  >
                    <i class="bi bi-eye" /> Lihat Posting
                  </router-link>

                  <a
                    v-if="
                      isAdmin &&
                      row.source !== 'instagram' &&
                      !cekMarks(row._id)
                    "
                    href="javascript:void(0)"
                    @click="markAccount(row._id)"
                    class="dropdown-item"
                  >
                    <i class="bi bi-bell"></i> Tandai Akun
                  </a>
                  <a
                    v-else-if="
                      isAdmin && row.source !== 'instagram' && cekMarks(row._id)
                    "
                    href="javascript:void(0)"
                    @click="unmarkAccount(row._id)"
                    class="dropdown-item text-danger"
                  >
                    <i class="bi bi-bell-slash"></i> Hilangkan Tanda
                  </a>

                  <a
                    href="javascript:void(0)"
                    @click="markPers(row._id)"
                    v-if="
                      isAdminUtama &&
                      row.source !== 'instagram' &&
                      !cekPers(row._id)
                    "
                    class="dropdown-item"
                  >
                    <i class="bi bi-newspaper" /> Jadikan Pers
                  </a>
                  <a
                    href="javascript:void(0)"
                    @click="unmarkPers(row._id)"
                    v-else-if="
                      isAdmin && row.source !== 'instagram' && cekPers(row._id)
                    "
                    class="dropdown-item text-danger"
                  >
                    <i class="bi bi-newspaper" /> Jadikan Non Pers
                  </a>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row m-t-10">
      <div class="col-md-6" />
      <div class="col-md-6">
        <pagination-component
          :key="pagination_key"
          v-if="page_info !== null && data.length > 0"
          :data="page_info"
          :goto="true"
          class="pull-right"
        />
      </div>
    </div>
    <modal-dynamic-component
      v-if="modal_data"
      :key="modal_key"
      :modal="modal_data"
    />
  </div>
</template>

<script>
import $ from "jquery";
import "datatables";
import pagination from "@/views/components/pagination.vue";
import loader from "@/views/components/loader.vue";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_filter_medsos from "@/views/components/sources/modal_filter_medsos.vue";
import gp from "@/plugins/generalPlugins.js";
import swal from "sweetalert";
import notif from "@/assets/js/notif.js";
$.pgNotification = notif;

var modal_data = {
  title: "Filter Data",
  subtitle: "Anda dapat melakukan filter data disini",
  component: modal_filter_medsos,
};

var icon_sources = [];
icon_sources["facebook"] = "bi bi-facebook";
icon_sources["twitter"] = "bi bi-twitter";
icon_sources["instagram"] = "bi bi-instagram";
icon_sources["youtube"] = "bi bi-youtube";
icon_sources["tiktok"] = "bi bi-tiktok";
icon_sources["linkedin"] = "bi bi-linkedin";
icon_sources["blog"] = "bi bi-rss";
icon_sources["forum"] = "bi bi-chat-dots-fill";
icon_sources["review"] = "bi bi-phone";

export default {
  name: "table_medsos",
  data() {
    return {
      modal_data: null,
      data: null,
      modal_post_account: null,
      icon_sources: this.$icon,
      page_info: null,
      pagination_key: 0,
      query: null,
      start_count: 1,
      data_empty: false,
      pers: [],
      marks: [],
      modal_key: 10,
      modal_post_key: 20,
      q_account: null,
      id_project: this.$store.getters.user.id_project,
    };
  },
  components: {
    "pagination-component": pagination,
    "loader-component": loader,
    "modal-dynamic-component": modal_dynamic,
  },
  methods: {
    btnToggle: function (event) {
      var dd;
      if ($(event.target).prop("tagName") == "I") {
        dd = $(event.target).parent().next();
      } else {
        dd = $(event.target).next();
      }
      let urutan_row = dd.attr("data-order");
      let transform_y = "24px";
      let total_data = this.data.length;
      if (urutan_row > total_data - 3 && total_data > 1) {
        transform_y = "-93px";
      }

      var display = dd.css("display");
      if (display == "none") {
        var $trigger = $(event.target);
        if ($trigger !== event.target && !$trigger.has(event.target).length) {
          $(".dropdown .dropdown-menu").removeClass("show");
        }
        var style =
          "position: absolute; transform: translate3d(-115px, " +
          transform_y +
          ", 0px); top: 0px; right: -115px; will-change: transform;";
        dd.attr("style", style);
        dd.addClass("show");
        dd.slideDown("fast");
      } else {
        dd.removeClass("show");
      }
    },
    showFilter: function () {
      this.modal_data = modal_data;
      this.modal_key++;
    },
    getData: function () {
      var self = this;
      var params = this.$route.query;
      params.items = 20;
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      if (query != "") {
        this.query = query;
        let api =
          process.env.VUE_APP_API_URL +
          "influencers/" +
          this.id_project +
          "/socmed?" +
          query;
        this.$http
          .get(api)
          .then(function (response) {
            if (response.status == 204) {
              self.data = {};
              self.page_info = {};
              self.data_empty = true;
            } else {
              self.data = response.data.accounts;
              self.page_info = response.data.page_info[0];
              self.pagination_key++;
              self.start_count =
                (self.page_info.page - 1) * self.page_info.limit + 1;
              self.data_empty = false;
            }
          })
          .catch(function (err) {
            self.resp = err.response;
            self.isError = true;
          })
          .finally(function () {
            self.isLoading = false;
          });
      }
    },
    getPers: function () {
      var self = this;
      let api = process.env.VUE_APP_API_URL + "pers";
      this.$http
        .get(api)
        .then(function (response) {
          if (response.status != 204) {
            self.pers = response.data;
          } else {
            self.pers = [];
          }
        })
        .catch(function () {
          self.pers = [];
        });
    },
    getMarks: function () {
      var self = this;
      let api =
        process.env.VUE_APP_API_URL + "marked-accounts/" + this.id_project;
      this.marks = [];
      this.$http.get(api).then(function (response) {
        if (response.status != 204) {
          self.marks = response.data;
        }
      });
    },
    markPers: function (url) {
      let self = this;

      swal({
        title: "Apakah anda yakin?",
        text: "Menandai akun tersebut sebagai Pers.",
        buttons: ["Batal", "Ya"],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          let params = {
            url: url,
          };
          let api = process.env.VUE_APP_API_URL + "pers-add";
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                self.getPers();
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Akun berhasil ditandai sebagai pers.',
                    position: "top",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
              } else {
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menandai akun sebagai pers.',
                    position: "top",
                    timeout: 5000,
                    type: "danger",
                  })
                  .show();
              }
            })
            .catch(function (error) {
              console.log(error);
            })
            .finally(function () {
              self.getPers();
            });
        }
      });
    },
    unmarkPers: function (url) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Menandai akun tersebut sebagai Pers.",
        buttons: ["Batal", "Ya"],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          let params = {
            url: url.toString(),
          };
          let api = process.env.VUE_APP_API_URL + "pers-delete";
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Akun berhasil dihapus dari daftar pers.',
                    position: "top",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
              } else {
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus akun dari daftar pers.',
                    position: "top",
                    timeout: 5000,
                    type: "danger",
                  })
                  .show();
              }
            })
            .catch(function (error) {
              console.log(error);
            })
            .finally(function () {
              self.getPers();
            });
        }
      });
    },
    cekPers: function (_id) {
      if (this.pers != null) {
        return this.pers.includes(_id);
      } else {
        return false;
      }
    },
    markAccount: function (url) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Menandai akun tersebut. Anda akan mendapatkan pemberitahuan ketika akun yang ditandai memposting konten yang mengandung kata kunci",
        buttons: ["Batal", "Ya"],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          let params = {
            url: url,
            id_project: this.id_project,
          };
          let api = process.env.VUE_APP_API_URL + "marked-accounts-add";
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Akun berhasil ditandai.',
                    position: "top",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
              } else {
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menandai akun.',
                    position: "top",
                    timeout: 5000,
                    type: "danger",
                  })
                  .show();
              }
            })
            .catch(function (error) {
              console.log(error);
            })
            .finally(function () {
              self.getMarks();
            });
        }
      });
    },
    unmarkAccount: function (url) {
      let self = this;

      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus akun tersebut dalam daftar akun yang ditandai.",
        buttons: ["Batal", "Ya"],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          let params = {
            url: url,
            id_project: this.id_project,
          };
          let api = process.env.VUE_APP_API_URL + "marked-accounts-delete";
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Akun berhasil dihapus dari daftar akun ditandai.',
                    position: "top",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
              } else {
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus akun dari daftar akun ditandai.',
                    position: "top",
                    timeout: 5000,
                    type: "danger",
                  })
                  .show();
              }
            })
            .catch(function (error) {
              console.log(error);
            })
            .finally(function () {
              self.getMarks();
            });
        }
      });
    },
    cekMarks: function (_id) {
      if (this.marks != null) {
        return this.marks.includes(_id);
      } else {
        return false;
      }
    },
    sort: function (sort_by) {
      let queries = JSON.parse(JSON.stringify(this.$route.query));

      if ("sort" in queries) {
        if (queries.sort != sort_by) {
          queries.sort = sort_by;
          this.$router.replace({ query: queries });

          let other_th = $(event.target)
            .parent()
            .children()
            .children(".bi-caret-down-fill");
          other_th.removeClass("bi-caret-down-fill");
          other_th.addClass("fa-sort");

          $(event.target).children(".bi").removeClass("fa-sort");
          $(event.target).children(".bi").addClass("bi-caret-down-fill");
        }
      } else {
        queries.sort = sort_by;
        this.$router.replace({ query: queries });

        let other_th = $(event.target)
          .parent()
          .children()
          .children("bi-caret-down-fill");
        other_th.removeClass("bi-caret-down-fill");
        other_th.addClass("fa-sort");

        $(event.target).children(".bi").removeClass("fa-sort");
        $(event.target).children(".bi").addClass("bi-caret-down-fill");
      }
    },
    showPost(index) {
      let account = this.data[index];
      this.$router.push({
        path: "/detail-akun",
        query: { account: account.account, key: btoa(account._id) },
      });
    },
    searchData: function () {
      if (this.q_account == "") {
        let queries = JSON.parse(JSON.stringify(this.$route.query));
        delete queries.q_account;
        this.$router.replace({ query: queries });
      } else {
        let queries = JSON.parse(JSON.stringify(this.$route.query));
        queries.q_account = btoa(this.q_account);
        this.$router.replace({ query: queries });
      }
    },
    encodeId(id) {
      return btoa(id);
    },
  },
  filters: {
    thousandSeparator: function (number) {
      if (number) {
        return gp.thousandSeparator(number);
      }
      return 0;
    },
  },
  watch: {
    $route() {
      var params = this.$route.query;
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      if (this.query != query && query != "") {
        this.getData();
      }
    },
  },
  computed: {
    isAdmin: function () {
      let user_role = this.$store.getters.user.role;
      if (user_role == 2 || user_role == 3) {
        return true;
      }
      return false;
    },
    isAdminUtama: function () {
      let user_role = this.$store.getters.user.role;
      if (user_role == 2) {
        return true;
      }
      return false;
    },
  },
  created: function () {
    let queries = JSON.parse(JSON.stringify(this.$route.query));
    let param_exist = 0;
    if ("pers" in queries) {
      delete queries.pers;
      param_exist++;
    }
    if ("marked" in queries) {
      delete queries.marked;
      param_exist++;
    }
    if ("sources" in queries) {
      delete queries.sources;
      param_exist++;
    }
    if ("sort" in queries) {
      delete queries.sort;
      param_exist++;
    }
    if ("page" in queries) {
      if (queries.page > 1) {
        queries.page = 1;
        param_exist++;
      }
    }
    if ("q_account" in queries) {
      delete queries.q_account;
      param_exist++;
    }
    if (param_exist > 0) {
      this.$router.replace({ query: queries });
    }
    this.getPers();
    this.getMarks();
    this.getData();
  },
};
</script>

<style scoped>
@import "../../../../public/assets/plugins/bootstrap-social/bootstrap-social.css";
@import "../../../assets/css/jquery.dataTables.css";

.table thead th {
  border-top: 1px solid rgba(224, 224, 224, 0.7);
  border-bottom: 1px black solid !important;
}
select.form-control {
  -webkit-appearance: button !important;
  cursor: pointer;
}
</style>